var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-new-confirm-design"
  }, [_vm.showStepsView ? _c('div', {
    staticClass: "ugc-new-confirm-design-steps-view-wrapper"
  }, [_c('ugc-new-steps-view')], 1) : _vm._e(), _c('div', {
    staticClass: "ugc-new-confirm-design-spinner text-center"
  }, [_c('base-spinner', {
    ref: "spinner",
    attrs: {
      "set-spinner-default": _vm.showSpinner,
      "size": "60",
      "position": "initial"
    }
  })], 1), _c('div', {
    staticClass: "ugc-new-confirm-design-image-wrapper"
  }, [_vm.compositeImgKey ? _c('img', {
    attrs: {
      "src": _vm.imagesPreview[_vm.compositeImgKey].imgSrc,
      "alt": _vm.pdm.product_name
    },
    on: {
      "load": _vm.onPreviewImageLoaded
    }
  }) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }